import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HierarchyEntityDetails } from '../interfaces/branch-data';
import { Observable } from 'rxjs';
import {
    Branch,
    BranchEmpData,
} from '../../performance/components/performance-projections-config/performance-projection.data';

@Injectable({
    providedIn: 'root',
})
export class BranchService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/branch').replace('{version}', this.version);

    constructor(private http: HttpClient) {}

    getBranchDetails(id: string): Observable<HierarchyEntityDetails> {
        return new Observable((subscriber) => {
            this.http
                .post<HierarchyEntityDetails>(this._url + '/getBranchDetails', {
                    BranchID: id,
                })
                .subscribe(
                    (details) => {
                        subscriber.next(details);
                    },
                    (response) => {
                        subscriber.error(response);
                    }
                );
        });
    }

    public getBranchesOfInterest(): Observable<Branch[]> {
        return this.http.get<Branch[]>(`${this._url}/branch/all`);
    }

    getAllRelatedBranches(): Observable<BranchEmpData> {
        return this.http.get<BranchEmpData>(`${this._url}/branch/alllevels`);
    }

    getCurrentUsersBranchRecord(): Observable<HierarchyEntityDetails> {
        return this.http.get<HierarchyEntityDetails>(this._url + '/GetCurrentUsersBranchRecord');
    }

    getAllBranchesForClientKey(): Observable<Branch[]> {
        return this.http.get<Branch[]>(this._url + '/GetAllBranchesForClientKey');
    }
}
